<template>
  <div class="common">
    <search-form
    :noAdvance="true"
    :formConfig="formConfig"
    :source="searchData"
    @search="search"
    >
    </search-form>

    <div class="table-common">
      <a-table
        size="middle"
        :columns="columns"
        :data-source="tableData"
        :pagination="pagination"
        :loading="loading"
        :row-key="(record,index) => record.id"
        @change="handleTableChange"
        bordered
        :locale="{emptyText: '暂无数据'}"
        :row-selection="tableSelect"
      >
        <template slot="tranAmt" slot-scope="text">{{text | splitK}}</template>
        <template slot="tranTime" slot-scope="text">{{text | dateFormat('YYYY-mm-dd HH:MM')}}</template>
        <template slot="tranDate" slot-scope="text,record">{{transDate(text) + " " + transTime(record.tranTime)}}</template>
        <template slot="tranType" slot-scope="text">{{text | tranType}}</template>
        <template slot="remark" slot-scope="text,record">{{text || record.memo}}</template>
        <template slot="loanFlag" slot-scope="text">{{text | loanFlagEntries}}</template>
      </a-table>
      <div :class="{'table-total':pagination.total>0,'table-total-none':pagination.total==0}">
        共有记录：
        <span class="">{{pagination.total}} 条</span>
        已选明细：
        <span class="text-color-blue">{{selectedRows.length}} 条</span>
        <a-button v-if="tabType=='receiptCol'" class="btn-blue-line" :disabled="selectedRowKeys.length==0" @click="onPrint">打印</a-button>
        <a-button v-else class="btn-blue-line" :disabled="selectedRowKeys.length==0" @click="onExport">导出</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters,mapMutations} from "vuex"
import { pagingFncDetails } from "@/api/fncDetails.js"
import {getUserInfoApi} from "@/api/center.js"
export default {
    props:{
        tabType:{
            type: [String],
            required: false,
            default: function () {
                return ""; //所属tab的分类
            }
        },
        status:{
            type: [String],
            required: false,
            default: function () {
                return "";
            }
        },
    },
    name: "funding-main",
    components:{
    },
    data() {
        return {
            searchData:{
                tranTime:[],
                tranType:""
            },
            formConfig:[
                {
                    prop: "tranType",
                    type: "tags",
                    label: "类型",
                    hide:this.tabType=="receiptCol",
                    option:[
                        { value: 'all', name: '全部' },
                        { value: 'BF', name: '转账' },
                        { value: 'BH', name: '解冻支付' },
                        { value: 'BS', name: '支付冻结' },
                        { value: 'TX', name: '提现' }
                    ]
                },
                {
                    prop: "tranTime",
                    type: "dateRange",
                    label: "交易日期",
                }
            ],
            columns: [
                {
                    title:"交易日期",
                    width:"130px",
                    dataIndex: "tranTime",
                    scopedSlots: { customRender: "tranTime" },
                    hide:this.tabType=="receiptCol",
                },
                {
                    title:"交易日期",
                    width:"130px",
                    dataIndex: "tranDate",
                    scopedSlots: { customRender: "tranDate" },
                    hide:this.tabType!="receiptCol",
                },
                {
                    title:"类型	",
                    dataIndex: "tranType",
                    width:"80px",
                    scopedSlots: { customRender: "tranType" },
                    hide:this.tabType=="receiptCol"
                },
                {
                    title:"金额(元)	",
                    dataIndex: "tranAmt",
                    scopedSlots: { customRender: "tranAmt" },
                    hide:this.tabType=="receiptCol"
                },
                {
                    title: "交易方",
                    dataIndex: "oppAccNm",
                    hide:this.tabType=="receiptCol"
                },
                {
                    title: "银行流水号",
                    dataIndex: "clientId",
                    hide:this.tabType=="receiptCol"
                },
                {
                    title: "对方账户名称",
                    dataIndex: "accountNm",
                    hide:this.tabType!="receiptCol"
                },
                {
                    title: "对方账号",
                    dataIndex: "accountNo",
                    hide:this.tabType!="receiptCol"
                },
                {
                    title: "借贷标志",
                    dataIndex: "loanFlag",
                    hide:this.tabType!="receiptCol",
                    scopedSlots: { customRender: "loanFlag" },
                },
                {
                    title: "金额",
                    dataIndex: "tranAmt",
                    hide:this.tabType!="receiptCol"
                },
                {
                    title: "摘要",
                    dataIndex: "remark",
                    scopedSlots: { customRender: "remark" },
                    // width:"220px"
                },

            ],
            tableData: [],
            pagination: {
                pageSize: 10,
                current: 1,
                sortField: "",
                sortOrder: "",
                total: 0,
                showSizeChanger:true,
                showQuickJumper:true,
                pageSizeOptions:['5','10', '20', '50','100'],
                showTotal:(total)=>{
                return `共 ${total} 条`
                }
            },
            loading: false,
            selectedRows: [],
            selectedRowKeys:[],
            tableDataAllPage:[]

        };
    },
    computed: {
        ...mapGetters({
            userObj:"home/getUserObj"
        }),
        tableSelect(){
            return {
                selectedRowKeys: this.selectedRowKeys,
                selectedRows: this.selectedRows,
                onChange: this.onTableChange
            }
        },
    },
    methods: {
        search(data) {
            this.searchData = data || this.searchData;
            this.getTableData();
        },
        getTableData(){
            this.loading = true;
            const params = {
                tab: this.status,
                tranType: this.searchData.tranType=="all"?"":this.searchData.tranType,
                tranTimeStart: this.searchData.tranTime[0],
                tranTimeEnd: this.searchData.tranTime[1],
                pageNum: this.pagination.current,
                pageSize: this.pagination.pageSize
            };
            pagingFncDetails(params)
            .then((res)=>{
                this.loading = false;
                this.pagination.total = res.data.grid.total||0;
                this.tableData = res.data.grid.list || [];
                this.renderTableAllPage();
            })
            .catch(err => {
                this.loading = false;
                console.log(err);
            })
        },
        totalPayable(list=[],prop="thsFncAmt") {
            return list.reduce((acc, rec) => {
                return acc + (+rec[prop] || 0);
            }, 0);
        },
        handleTableChange(pagination, filters, sorter) { //表格排序回调
            this.pagination = {
                current: pagination.current,
                pageSize: pagination.pageSize,
                total: this.pagination.total || 0,
            };
            this.getTableData();
        },
        onTableChange(selectedRows, data, data2) { //表格选择回调
            this.selectedRowKeys = selectedRows;
            this.selectedRows = this.tableDataAllPage.filter(item => selectedRows.indexOf(item.id)>-1);
        },
        renderTableAllPage(){ //记录加载的数据，用于记录选中的表格数据
            this.tableData.forEach(i => {
                let flag = this.tableDataAllPage.find(item => item.id == i.id);
                let idList = this.tableDataAllPage.map(i => i.id)
                if(!flag && idList.indexOf(i.id) == -1){
                    this.tableDataAllPage.push(i);
                }
            })
        },
        onExport() {
            const path = '/user/fncDetails/outportFncDetails?ids=';
            const ids = this.selectedRowKeys.join(",");
            const url = process.env.VUE_APP_BASE_API + `${path}${ids}`;
            window.open(url);
            this.selectedRows = [];
            this.selectedRowKeys = [];
        },
        onPrint() {
            const verifyCodeList = this.selectedRows.map(resp => resp.verifyCode);
            const param = '&verifyCode=1234&EMP_SID=FKEPHDIBEJIJIZIYCJECGLBFBXHRBXBPGICVDCEF';
            getUserInfoApi()
            .then(res => {
                const subAccNo = res.data.accNo;
                for (const value of verifyCodeList) {
                    const url = process.env.VUE_APP_PRINT_URL + `?subAccNo=${subAccNo}&printVerifyCode=${value}${param}`;
                    window.open(url, '_blank');
                }
            })
            .catch(err => {
                console.log(err);
            })
        },
        transDate(num) {
            const yearStr = num.substring(0, 4);
            const monthStr = num.substring(4, 6);
            const dateStr = num.substring(6, 8);
            const backStr = `${yearStr}-${monthStr}-${dateStr}`;
            return backStr;
        },

        transTime(num) {
            const hourStr = num.substring(0, 2);
            const minuteStr = num.substring(2, 4);
            const secondStr = num.substring(4, 6);
            const backStr = `${hourStr}:${minuteStr}:${secondStr}`;
            return backStr;
        },
        refresh(){
            this.tableDataAllPage = [];
            this.selectedRows = [];
            this.selectedRowKeys = [];
            this.getTableData();
        }
    },
    created() {
        this.formConfig = this.formConfig.filter(i => !i.hide);
        this.columns = this.columns.filter(i => !i.hide);
        this.getTableData();
    },
    mounted() {},
    activated() {},
};
</script>
<style scoped>
    .input-content>div{
        margin:10px 20px 20px 0;
    }
    .common /deep/ .search-item-lable-left{
        min-width: auto!important;
    }
</style>



// WEBPACK FOOTER //
// src/pages/account/funding-main.vue